import { useV2ListAttachmentTypesForAccountQuery } from "@generated";

export interface AttachmentTypeOption {
  value: string;
  label: string;
}

export const useAttachmentTypeOptions = () => {
  // Attachment types are a small per-account catalog; one page of 100 active
  // types is sufficient for the dropdown. Revisit if accounts exceed that.
  const { data, isLoading } = useV2ListAttachmentTypesForAccountQuery(
    { page: { number: 1, size: 100 }, filter: { active: true } },
    { refetchOnMountOrArgChange: true }
  );

  const options: AttachmentTypeOption[] = ((data?.data as any[]) ?? []).map(
    (t) => ({ value: String(t.id), label: t?.attributes?.name ?? "" })
  );

  return { options, isLoading };
};

export default useAttachmentTypeOptions;
